module.exports = __webpack_public_path__ + "img/chair-icon.595a618e.svg";